// @LTG-ID: F-050
// @STATUS: BUILT
// @HERMETIC: true
// @CHANGED: 2026-02 CHG-0117 (CRO sweep · testimonials grid)
// @OWNER: web
//
// F-050 · Testimonials grid (Block 2 of CHG-0117 Phase 4). 2x2 desktop,
// single column mobile. Quotes are attribution-anonymized to industry +
// region only; no client names, no dollar amounts, no dates. See
// chg_0117_decisions_log.md DECISION-036 for the Quote 4 "no fluff" →
// "no filler" tone-swap rationale.

import "./testimonials.css";

const QUOTES = [
    {
        id: "hvac",
        text: "The Strategic Snapshot gave me clarity I didn't have before. It helped me see my business the way a buyer would.",
        attribution: "Owner, HVAC services · Charlotte, NC",
    },
    {
        id: "dental",
        text: "Super straightforward and easy to understand. The CPA sign-off was what made it credible for my partners.",
        attribution: "Owner, dental practice · Raleigh, NC",
    },
    {
        id: "marketing",
        text: "The report gave me three concrete moves I could make in the next quarter. That's exactly what I needed.",
        attribution: "Owner, marketing agency · Austin, TX",
    },
    {
        id: "it",
        text: "Fast, professional, and no filler. The valuation was defensible enough to use in a partner buyout conversation.",
        attribution: "Owner, IT services · Denver, CO",
    },
];

export function Testimonials() {
    return (
        <section
            className="ltg-testimonials"
            id="testimonials"
            data-testid="testimonials-grid"
        >
            <div className="ltg-container">
                <h2
                    className="ltg-testimonials__h2"
                    data-testid="testimonials-h2"
                >
                    What owners are saying
                </h2>
                <div className="ltg-testimonials__grid">
                    {QUOTES.map((q) => (
                        <figure
                            key={q.id}
                            className="ltg-testimonial-card"
                            data-testid={`testimonial-${q.id}`}
                        >
                            <blockquote>
                                <p>{q.text}</p>
                            </blockquote>
                            <figcaption>{q.attribution}</figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Testimonials;
